import { useUpdateUserSettings } from 'features/user';
import { useKeysDown } from 'shared/hooks/use-keys-down';
import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';
import { InsightsTimeframes } from 'shared/types/insights';
import { LimitKeys } from 'shared/types/limit-keys';
import { targetIsInput } from 'shared/utils/target-is-input';

export const useKeyboardShortcutTimeframeSelection = () => {
  const updateUserSettings = useUpdateUserSettings();
  const { allowed } = usePremiumFeatureAllowed(LimitKeys.Insights, {});

  const _updateGenerator =
    (timeframe: InsightsTimeframes) => (e: KeyboardEvent) => {
      if (!allowed || targetIsInput(e.target)) {
        return; // Don't open dialog
      }

      updateUserSettings({ insights: { timeframe } });
    };

  useKeysDown(['KeyW'], _updateGenerator(InsightsTimeframes.Week), {
    otherKeysInCombinationAllowed: true,
  });
  useKeysDown(['KeyM'], _updateGenerator(InsightsTimeframes.Month), {
    otherKeysInCombinationAllowed: true,
  });
  useKeysDown(['KeyQ'], _updateGenerator(InsightsTimeframes.Quarter), {
    otherKeysInCombinationAllowed: true,
  });
  useKeysDown(['KeyY'], _updateGenerator(InsightsTimeframes.Year), {
    otherKeysInCombinationAllowed: true,
  });
};
